import { Modal } from "../Modal"
import { useTranslation } from "react-i18next"

type ReadOnlyNoticeModalProps = {
  isOpen: boolean
  onClose: () => void
  message: string
}

export function ReadOnlyNoticeModal({ isOpen, onClose, message }: ReadOnlyNoticeModalProps) {
  const { t } = useTranslation()

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="flex flex-col items-center justify-center w-[520px] h-[220px] px-[25px]"
    >
      <span className="text-black text-center">
        <p>{message}</p>
        <p>{t("readonly.description")}</p>
      </span>
      <button
        className="mt-[18px] w-[160px] h-[47px] border-[1.5px] border-[#C5C7FF] rounded-[50px] text-[#545899] font-bold"
        onClick={onClose}
      >
        {t("common.close")}
      </button>
    </Modal>
  )
}
